import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import StatusBadge from '../components/shared/StatusBadge';

const STATUSES = ['', 'PENDING_PAYMENT', 'AWAITING_VERIFICATION', 'CONFIRMED', 'PACKED', 'SHIPPED', 'DELIVERED', 'CANCELLED'];

export default function Orders() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('');

  const load = () => {
    const q = filter ? `?status_filter=${filter}` : '';
    api.get('/orders' + q).then(({ data }) => setItems(data.items));
  };
  useEffect(() => { load(); }, [filter]);

  const fmt = (n) => '₹' + Number(n || 0).toLocaleString('en-IN');

  return (
    <div className="space-y-5 fade-up">
      <div className="flex flex-wrap gap-2">
        {STATUSES.map((s) => (
          <button key={s || 'all'} onClick={() => setFilter(s)} className={`px-3 py-1.5 rounded-full text-[12px] font-semibold ${filter === s ? 'bg-fab-primary text-white' : 'bg-white text-fab-text-secondary border border-fab-primary-lighter hover:bg-fab-elevated'}`}>
            {s ? s.replace('_', ' ') : 'All Orders'}
          </button>
        ))}
      </div>

      <div className="fab-card overflow-x-auto overflow-y-hidden">
        <table className="w-full text-[13px]" data-testid="orders-table">
          <thead>
            <tr className="text-[10px] text-fab-text-muted uppercase tracking-wider bg-fab-elevated">
              <th className="text-left px-4 py-3 font-semibold">Order ID</th>
              <th className="text-left px-4 py-3 font-semibold">Buyer</th>
              <th className="text-left px-4 py-3 font-semibold">Items</th>
              <th className="text-left px-4 py-3 font-semibold">Amount</th>
              <th className="text-left px-4 py-3 font-semibold">Status</th>
              <th className="text-left px-4 py-3 font-semibold">Date</th>
            </tr>
          </thead>
          <tbody>
            {items.map((o) => (
              <tr key={o.id} className="border-b border-fab-primary-lighter last:border-0 hover:bg-fab-elevated">
                <td className="px-4 py-3"><Link to={`/dashboard/orders/${o.id}`} className="text-fab-primary font-semibold font-mono">{o.order_number}</Link></td>
                <td className="px-4 py-3 text-fab-text">{o.buyer_name}<div className="text-[11px] text-fab-text-muted">{o.buyer_phone}</div></td>
                <td className="px-4 py-3 text-fab-text-secondary">{o.items?.length} items</td>
                <td className="px-4 py-3 text-fab-text font-semibold">{fmt(o.total_amount)}</td>
                <td className="px-4 py-3"><StatusBadge status={o.status} size="sm" /></td>
                <td className="px-4 py-3 text-fab-text-muted">{new Date(o.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="6" className="text-center text-fab-text-muted py-12">No orders found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
